import { Base } from './base';
import { IValidatorMessage, IValidationRule } from '../types';

interface IValidatorError {
  message: IValidatorMessage;
  value: any;
}

/**
 * Define passive validator
 * @param {I18nModel} i18n - provide callback getString to get message
 */
class Passive extends Base implements IValidationRule {
  error: IValidatorError | null;

  constructor(i18n: I18nModel) {
    super(i18n);
    this.error = null;
  }

  /**
   * Check whether value is valid
   * @param {any} value - value to be checked
   * @returns {boolean} - if value is valid return true, otherwise, return false
   */
  isValid(value: any): boolean {
    if (this.error && this.error.value === value) {
      return false;
    }
    this.error = null;
    return true;
  }

  /**
   * Set error value and correspond message
   * @param {IValidatorMessage} message - message of error
   * @param {any} value - error value
   * @returns {void}
   */
  setError(message: IValidatorMessage, value: any): void {
    this.error = {
      message,
      value,
    };
    this.message = message;
  }
}

/**
 * Create passive validator instance
 * @param {I18nModel} i18n - provide callback getString to get message
 * @returns {IValidationRule} - return passive validator instance
 */
export function passive(i18n: I18nModel): IValidationRule {
  return new Passive(i18n);
}
